import { InjectionToken } from '@angular/core';

export interface ModalRef {
  dismiss(data?: unknown): void;
}

export const MODAL_REF = new InjectionToken<ModalRef>('MODAL_REF');
